import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "max-w-[500px] mx-auto py-6"
}
const _hoisted_2 = { class: "col-span-2" }
const _hoisted_3 = { class: "flex items-center justify-end w-full space-x-3" }
const _hoisted_4 = { href: "/office/index/" }

import { ref, onMounted } from 'vue';
import UserLayout from '@/layouts/UserLayout.vue';
import FormSection from './FormSection.vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import PageLoader from "@/components/loaders/PageLoader.vue"
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import SuccessModal from '@/components/modals/SuccessModal.vue';
import ErrorModal from "@/components/modals/ErrorModal.vue";
import { errorResponse } from "@/helpers/errorMessage";

import Offices from "@/classes/Offices";
import {
    OfficeUpdateDataInterface,
    SelectInterface
} from "@/interfaces/pages/offices/OfficeInterface"

import pickBy from "lodash/pickBy";

import assignValues from "@/helpers/assignValues"
import { hasPermission } from "@/classes/AuthService";
import { useRoute, useRouter } from "vue-router";
import Storage from "@/helpers/storage";
import { RoleTypes } from '../enums/RoleTypes';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const loading = ref<boolean>(false);
const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const loaded = ref<boolean>(false);
const successMessage = ref<string>('');
const errors = ref<any>();

const form = ref<OfficeUpdateDataInterface>({
    id: parseInt(route.params.office),
    name: '',
    prefix: '',
    contact_number: '',
    address: '',
    region_id: 0,
    province_id: 0,
    city_id: 0,
    barangay_id: 0,
    status: 1,
    encoded_by: 0,
    file_url: null,
    iso_intake: '',
    iso_scar: '',
    iso_assessment: '',
    iso_patient_profile: '', 
});

const regionOptions = ref<SelectInterface[]>([]);
const provinceOptions = ref<SelectInterface[]>([]);
const cityOptions = ref<SelectInterface[]>([]);
const barangayOptions = ref<SelectInterface[]>([]);
const showError = ref(false);
const showErrorMessage = ref(null);
const tokens = new Storage();
const user = JSON.parse(tokens.get("user"));

const init = (): void => {
    loading.value = true; 

    Offices.edit(form.value.id, pickBy(form.value))
        .then(({ data }) => { 
            form.value = assignValues(form.value, data.item);
            loading.value = false;
            loaded.value = true;
        })
}

const save = (): void => {
    loading.value = true; 

    Offices.update(form.value.id, form.value)
        .then((response: any) => {
            loading.value = false;
            successMessage.value = response.data.message;
            showSuccess.value = true;
            showConfirmation.value = false
        })
        .catch((error: any) => {
            loading.value = false;
            showConfirmation.value = false
            errors.value = errorResponse(error.response?.data?.errors)
            showError.value = true;
            showErrorMessage.value = 'Please fill up all required fields/Error Saving';
        });
}

const canUpdate = () => {
    if (user.role_id == RoleTypes.SUPERADMIN || user.role_id == RoleTypes.SUPERADMIN_IT) {
        return true;
    }

    return false;
}

onMounted(() => {
    init()
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backLink: "/office/index"
  }, {
    default: _withCtx(() => [
      (loaded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (!loading.value)
              ? (_openBlock(), _createBlock(FormSection, {
                  key: 0,
                  form: form.value,
                  errors: errors.value,
                  regionOptions: regionOptions.value,
                  provinceOptions: provinceOptions.value,
                  cityOptions: cityOptions.value,
                  barangayOptions: barangayOptions.value,
                  "onUpdate:location": _cache[4] || (_cache[4] = ($event: any) => (init()))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("a", _hoisted_4, [
                          _createVNode(ButtonComponent, { btnWidth: "quinary" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Cancel")
                            ]),
                            _: 1
                          })
                        ]),
                        (canUpdate())
                          ? (_openBlock(), _createBlock(ButtonComponent, {
                              key: 0,
                              btnWidth: "primary",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (showConfirmation.value = true))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Save Changes")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(ConfirmationModal, {
                        typeTwo: true,
                        show: showConfirmation.value,
                        onCancel: _cache[1] || (_cache[1] = ($event: any) => (showConfirmation.value = false)),
                        onConfirm: _cache[2] || (_cache[2] = ($event: any) => (save())),
                        "cancel-text": "Cancel",
                        "action-text": "Confirm",
                        title: "Save Record",
                        content: "Are you sure you wish to save this record?"
                      }, null, 8, ["show"]),
                      _createVNode(SuccessModal, {
                        show: showSuccess.value,
                        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (showSuccess.value = false, _ctx.$router.replace('/office/index'))),
                        "action-text": "Close",
                        title: "Succes!",
                        content: successMessage.value
                      }, null, 8, ["show", "content"])
                    ])
                  ]),
                  _: 1
                }, 8, ["form", "errors", "regionOptions", "provinceOptions", "cityOptions", "barangayOptions"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        show: showError.value,
        content: showErrorMessage.value
      }, null, 8, ["show", "content"]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})